import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { WithdrawalNotificationContent, WithdrawalSteps, WithdrawType } from '@inyova/models';

@Component({
  selector: 'app-withdrawal-notification',
  templateUrl: './withdrawal-notification.component.html',
  styleUrls: ['./withdrawal-notification.component.scss'],
  standalone: false
})
export class WithdrawalNotificationComponent implements OnInit {
  @Input() currentWdlStep: WithdrawalSteps;
  @Input() hasWithdrawalPromotion: boolean;
  @Input() isMobileApp: boolean;
  @Input() withdrawType: WithdrawType;
  @Output() activatePromotion: EventEmitter<void> = new EventEmitter<void>();
  @Output() nextStep: EventEmitter<WithdrawalSteps> = new EventEmitter<WithdrawalSteps>();
  @Output() cancelWithdrawal: EventEmitter<WithdrawalSteps> = new EventEmitter<WithdrawalSteps>();

  steps: typeof WithdrawalSteps = WithdrawalSteps;
  stepsContent: { [key: string]: WithdrawalNotificationContent };

  get activeStepContent(): WithdrawalNotificationContent {
    return this.stepsContent[this.currentWdlStep];
  }

  ngOnInit() {
    this.stepsContent = this.generateStepsContent(this.withdrawType);
  }

  onCancelWithdrawal() {
    if (this.currentWdlStep === WithdrawalSteps.PROMO_NOTIFICATION) {
      this.activatePromotion.emit();
    } else {
      this.cancelWithdrawal.emit(this.currentWdlStep);
    }
  }

  onContinue() {
    let nextStep: WithdrawalSteps;

    switch (this.currentWdlStep) {
      case WithdrawalSteps.UPDATE_NOTIFICATION:
        nextStep = WithdrawalSteps.IMPACT_NOTIFICATION;
        break;
      case WithdrawalSteps.IMPACT_NOTIFICATION:
        nextStep =
          this.hasWithdrawalPromotion || this.withdrawType === WithdrawType.PARTIAL ? WithdrawalSteps.IBAN : WithdrawalSteps.PROMO_NOTIFICATION;
        break;
      case WithdrawalSteps.PROMO_NOTIFICATION:
        nextStep = WithdrawalSteps.IBAN;
        break;
    }

    this.nextStep.emit(nextStep);
  }

  generateStepsContent(withdrawType: WithdrawType): { [key: string]: WithdrawalNotificationContent } {
    return {
      [WithdrawalSteps.UPDATE_NOTIFICATION as string]: {
        key: `${withdrawType === WithdrawType.FULL ? 'updates' : 'partialUpdates'}`,
        iconVariant: 'info',
        topics: [
          {
            icon: 'TreeDeciduous',
            key: 'eve2'
          },
          {
            icon: 'BarChart3',
            key: 'performance'
          },
          {
            icon: 'Leaf',
            key: 'impact'
          }
        ]
      },
      [WithdrawalSteps.IMPACT_NOTIFICATION as string]: {
        key: `${withdrawType === WithdrawType.FULL ? 'impact' : 'partialImpact'}`,
        iconVariant: 'success',
        topics: [
          {
            icon: 'ECar',
            key: 'ev'
          },
          {
            icon: 'Megaphone',
            key: 'ad'
          },
          {
            icon: 'HandHeart',
            key: 'insurance'
          }
        ]
      },
      [WithdrawalSteps.PROMO_NOTIFICATION as string]: {
        key: 'promo',
        iconVariant: 'warning',
        topics: [
          {
            icon: 'PiggyBank',
            key: 'fees'
          },
          {
            icon: 'Leaf',
            key: 'impact'
          },
          {
            icon: 'Sparkles',
            key: 'features'
          }
        ]
      }
    };
  }
}
